<template>
  <div class>
    <STable
      ref="tableref"
      :url="url"
      :columns="columns"
      :handles="handles"    
      :selection="false"
      :toolbar="toolbar"
      labelWidth="120px"
    ></STable>
    <div>
      <span>测试:{{searchCnt}} 进程:{{progress}}%  时间:{{nowTime}}</span>   
      <div>时间2:{{nowTime}}</div>   
    </div> 
  </div>
  
</template>

<script>
export default {
  name: "otaDeal",
  components: {},
  data() {
    return {
      projectId:'',
      deviceId:'',
      searchCnt:0,
      progress:0,
      reset:0,
      nowTime:new Date(),
      health :100,
      eable : false,
      url:"/battery/ota/FirmFileData?projectId=" + this.$route.query.data.projectId,
      columns: [        
        {
          label: "固件编号",
          prop: "firmSN",
        },
        {
          label: "固件名称",
          prop: "name",
        },
        {
          label: "应用项目",
          prop: "projectName",
        },
        {
          label: "固件版本",
          prop: "version",
        },
        {
          label: "备注",
          prop: "remark",
        },   
         {
          label: "更新时间",
          prop: "updateTime",
        }
      ], 
      
       //操作栏
       handles: {
        width: 300,
        btns: [ 
          //下发文件     
          {
            label: "远程下发固件",
            style: "color:#00CC00",
            permission: "1",
            handle: (resp) => {
              //this.currentDeviceId = resp.id;
              //this.issueDialogVisible = false;//暂时关闭原来的下发框
              let param = {
                //pid: this.$route.query.data.projectId,
                did:this.$route.query.data.id,
                fid:resp.id  
              } 
              this.$store.dispatch("form/handle", {
                url: "/battery/ota/command",
                data: param,
                method: "get",
                callback: (resp) => {
                  this.$notify({
                    title: "成功",
                    message: "下发指令成功",
                    type: "success"
                  });
                  this.issueDialogVisible = false;
                },
              });
            },
          },
          {
            label: "定时下载",
            style: "color:#00CC00",
            permission: "1",
            handle: (resp) => {  
                //let _this = this;
                this.timer2 = setInterval(() => { 
                  let param = {
                  //pid: this.$route.query.data.projectId,
                  did:this.$route.query.data.id,
                  fid:resp.id  
                }
                this.send_cnt+=1 
                this.$store.dispatch("form/handle", {
                  url: "/battery/ota/queryUp",
                  data: param,
                  method: "get2",
                  callback: (resp) => {
                    this.$notify({
                      title: "成功",
                      message: resp,
                      type: "success"
                    });
                    //this.issueDialogVisible = false;
                    this.progress = resp.progress
                  },
                });
                this.searchCnt+=1
                if(this.searchCnt>5){
                  if(this.timer2) {
                    clearInterval(this.timer2); //清除我们的定时器
                  }
                }
              }, 3000)
            }
          },
          {
            label:this.progress
          }          
         ]
       }               
    };
  },
  computed: {},
  methods: { 
    dateFormat(time){
      var date=new Date(time);
      var year=date.getFullYear();
      var month= date.getMonth()+1<10 ? "0"+(date.getMonth()+1) : date.getMonth()+1;
      var day=date.getDate()<10 ? "0"+date.getDate() : date.getDate();
      var hours=date.getHours()<10 ? "0"+date.getHours() : date.getHours();
      var minutes=date.getMinutes()<10 ? "0"+date.getMinutes() : date.getMinutes();
      var seconds=date.getSeconds()<10 ? "0"+date.getSeconds() : date.getSeconds();
      // 拼接
      return year+"-"+month+"-"+day+" "+hours+":"+minutes+":"+seconds;
    },
    timerQuery(){
      handle: (resp) => {                
              let param = {
                //pid: this.$route.query.data.projectId,
                did:this.$route.query.data.id,
                fid:resp.id  
              }
              this.send_cnt+=1 
              this.$store.dispatch("form/handle", {
              url: "/battery/ota/queryUp",
              data: param,
              method: "get",
              callback: (resp) => {
                  this.$notify({
                    title: "成功",
                    message: "下发指令成功",
                    type: "success"
                  });
                  this.issueDialogVisible = false;
                },
              }); 
              this.searchCnt+=1
                if(this.searchCnt>5){
                  if(this.timer2) {
                    clearInterval(this.timer2); //清除我们的定时器
                  }
                }                          
            }
    },
    sub() {
        this.health -= 10;
        if(this.health <= 0){
            this.eable = true;
        }
    },
    reset () {
        this.health = 100;
        this.eable = false;
    }
  },
  mounted() {
    //this.getFirmData();
    //this.getOnloadData();
    console.log("mounted加载")
    let _this = this; // 声明一个变量指向Vue实例this，保证作用域一致
    this.timer = setInterval(() => {
      _this.nowTime = _this.dateFormat(new Date()); // 修改数据date
      console.log("timer定时器开启")    
    }, 1000)
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer); // 在Vue实例销毁前，清除我们的定时器
    }
  }, //生命周期 - 销毁之前
  destroyed() {
    if (this.timer2) {
     clearInterval(this.timer2); // 在Vue实例销毁前，清除我们的定时器
    }
     
  }, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style lang="less" src="" scoped>

</style>



// WEBPACK FOOTER //
// src/views/BMS/deviceManagement/downFirmData.vue